// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    PutInspectionDataPointNotesByIdParam,
    PutInspectionDataPointNotesByIdBody,
    BaseResponseVoid,
    DeleteInspectionDataPointNotesByIdParam,
} from '../../types';

/**
 * 质检结果批注更新
 *
 * @export
 * @tags 质检结果批注
 * @link [PUT] /inspectionDataPointNotes/{id}
 * @param id
 */
export function putInspectionDataPointNotesById(
    data: PutInspectionDataPointNotesByIdBody,
    options: ApiOptions<PutInspectionDataPointNotesByIdParam, never> & {
        segments: PutInspectionDataPointNotesByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<
        PutInspectionDataPointNotesByIdBody,
        PutInspectionDataPointNotesByIdParam,
        never
    >('/inspectionDataPointNotes/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putInspectionDataPointNotesById',
    });
}

/**
 * 质检结果批注删除
 *
 * @export
 * @tags 质检结果批注
 * @link [DELETE] /inspectionDataPointNotes/{id}
 * @param id
 */
export function deleteInspectionDataPointNotesById(
    options: ApiOptions<DeleteInspectionDataPointNotesByIdParam, never> & {
        segments: DeleteInspectionDataPointNotesByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteInspectionDataPointNotesByIdParam, never>(
        '/inspectionDataPointNotes/{id}',
        { ...options, method: 'delete', __$requestCalleeName: 'deleteInspectionDataPointNotesById' }
    );
}

export const meta = [
    { tags: ['质检结果批注'], path: '/inspectionDataPointNotes/{id}', method: 'put' },
    { tags: ['质检结果批注'], path: '/inspectionDataPointNotes/{id}', method: 'delete' },
];
